import { render, staticRenderFns } from "./ActiveTournamentGameDetailsModal.vue?vue&type=template&id=3580c625&"
import script from "./ActiveTournamentGameDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ActiveTournamentGameDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports